/**
 * Tájegység - külföld   * ALSACE - Alsace   * BORDEAUX - Bordeaux   * BURGUNDY - Bourgogne   * LOIRE_VALLEY - Val de Loire   * MOSEL - Mosel   * PALATINATE - Pfalz   * RHEINHESSEN - Rheinhessen   * LAZIO - Lazio   * TUSCANY - Toscana   * TRENTINO_ALTO_ADIGE_AND_FRIULI - Trentino, Alto Adige és Friuli   * VENETO - Veneto   * SICILIA - Sicilia   * VINHO_VERDE - Vinho Verde   * MOLD - Penedés   * RIOJA - Rioja   * VALENCIA - Valencia   * BEAUJOLAIS - Beaujolais   * VALLEE_DU_RHONE - Vallee du Rhone   * LANGUEDOC_ROUSSILLON - Languedoc-Roussillon   * PIEDMONT - Piemonte   * TRENTINO_AND_ALTO_ADIGE - Trentino és Alto Adige   * DAO_BAIRRADA_AND_DOURO - Dao, Bairrada és Douro   * NAVARRE - Navarra   * VALDEPENAS - Valdepenas   * MADEIRA_AND_SETUBAL - Madeira és Setubal   * SHERRY - Sherry   * MARSALA - Marsala   * SAMOS_AND_MUSCAT_DE_LEMNOS - Samos és Muscat de Lemnos   * PORTO - Portói   * OTHER - Egyéb
 */
export type WineLandscapeUnitAbroad =
  | 'ALSACE'
  | 'BORDEAUX'
  | 'BURGUNDY'
  | 'LOIRE_VALLEY'
  | 'MOSEL'
  | 'PALATINATE'
  | 'RHEINHESSEN'
  | 'LAZIO'
  | 'TUSCANY'
  | 'TRENTINO_ALTO_ADIGE_AND_FRIULI'
  | 'VENETO'
  | 'SICILIA'
  | 'VINHO_VERDE'
  | 'MOLD'
  | 'RIOJA'
  | 'VALENCIA'
  | 'BEAUJOLAIS'
  | 'VALLEE_DU_RHONE'
  | 'LANGUEDOC_ROUSSILLON'
  | 'PIEDMONT'
  | 'TRENTINO_AND_ALTO_ADIGE'
  | 'DAO_BAIRRADA_AND_DOURO'
  | 'NAVARRE'
  | 'VALDEPENAS'
  | 'MADEIRA_AND_SETUBAL'
  | 'SHERRY'
  | 'MARSALA'
  | 'SAMOS_AND_MUSCAT_DE_LEMNOS'
  | 'PORTO'
  | 'TOKAJ'
  | 'OTHER_OEM_OFJ_WINE_REGION';

export const WineLandscapeUnitAbroad = {
  Alsace: 'ALSACE' as WineLandscapeUnitAbroad,
  Bordeaux: 'BORDEAUX' as WineLandscapeUnitAbroad,
  Burgundy: 'BURGUNDY' as WineLandscapeUnitAbroad,
  LoireValley: 'LOIRE_VALLEY' as WineLandscapeUnitAbroad,
  Mosel: 'MOSEL' as WineLandscapeUnitAbroad,
  Palatinate: 'PALATINATE' as WineLandscapeUnitAbroad,
  Rheinhessen: 'RHEINHESSEN' as WineLandscapeUnitAbroad,
  Lazio: 'LAZIO' as WineLandscapeUnitAbroad,
  Tuscany: 'TUSCANY' as WineLandscapeUnitAbroad,
  TrentinoAltoAdigeAndFriuli:
    'TRENTINO_ALTO_ADIGE_AND_FRIULI' as WineLandscapeUnitAbroad,
  Veneto: 'VENETO' as WineLandscapeUnitAbroad,
  Sicilia: 'SICILIA' as WineLandscapeUnitAbroad,
  VinhoVerde: 'VINHO_VERDE' as WineLandscapeUnitAbroad,
  Mold: 'MOLD' as WineLandscapeUnitAbroad,
  Rioja: 'RIOJA' as WineLandscapeUnitAbroad,
  Valencia: 'VALENCIA' as WineLandscapeUnitAbroad,
  Beaujolais: 'BEAUJOLAIS' as WineLandscapeUnitAbroad,
  ValleeDuRhone: 'VALLEE_DU_RHONE' as WineLandscapeUnitAbroad,
  LanguedocRoussillon: 'LANGUEDOC_ROUSSILLON' as WineLandscapeUnitAbroad,
  Piedmont: 'PIEDMONT' as WineLandscapeUnitAbroad,
  TrentinoAndAltoAdige: 'TRENTINO_AND_ALTO_ADIGE' as WineLandscapeUnitAbroad,
  DaoBairradaAndDouro: 'DAO_BAIRRADA_AND_DOURO' as WineLandscapeUnitAbroad,
  Navarre: 'NAVARRE' as WineLandscapeUnitAbroad,
  Valdepenas: 'VALDEPENAS' as WineLandscapeUnitAbroad,
  MadeiraAndSetubal: 'MADEIRA_AND_SETUBAL' as WineLandscapeUnitAbroad,
  Sherry: 'SHERRY' as WineLandscapeUnitAbroad,
  Marsala: 'MARSALA' as WineLandscapeUnitAbroad,
  SamosAndMuscatDeLemnos:
    'SAMOS_AND_MUSCAT_DE_LEMNOS' as WineLandscapeUnitAbroad,
  Porto: 'PORTO' as WineLandscapeUnitAbroad,
  Tokaj: 'TOKAJ' as WineLandscapeUnitAbroad,
  Other: 'OTHER_OEM_OFJ_WINE_REGION' as WineLandscapeUnitAbroad,
};
